import { render, staticRenderFns } from "./quantityPriceFreightModification.vue?vue&type=template&id=e1c9d008&scoped=true&"
import script from "./quantityPriceFreightModification.vue?vue&type=script&lang=js&"
export * from "./quantityPriceFreightModification.vue?vue&type=script&lang=js&"
import style0 from "./quantityPriceFreightModification.vue?vue&type=style&index=0&id=e1c9d008&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c9d008",
  null
  
)

export default component.exports